export default "__VITE_ASSET__Y8nO0cp3__"